import { rome } from './date';

type DateLike = string | Date;
type Input = DateLike | [DateLike, DateLike];

const pad = (n: number, w = 2) => String(n).padStart(w, '0');

const extract = (val: DateLike, preferStart: boolean) => {
    const m = rome(val);
    let h = m.hours();
    let mi = m.minutes();
    let s = m.seconds();
    let ms = m.milliseconds();
    if (h + mi + s + ms === 0 && !preferStart) {
        h = 23;
        mi = 59;
        s = 59;
        ms = 999;
    }
    return { y: m.year(), m: m.month() + 1, d: m.date(), h, mi, s, ms };
};

const fmt = (o: { y: number; m: number; d: number; h: number; mi: number; s: number; ms: number }) =>
    `${o.y}-${pad(o.m)}-${pad(o.d)}T${pad(o.h)}:${pad(o.mi)}:${pad(o.s)}.${pad(o.ms, 3)}`;

const one = (v: DateLike, start: boolean) => fmt(extract(v, start));

export const getDateRange = (input: Input | null | undefined) => {
    if (!input) return null;
    if (Array.isArray(input)) {
        return { dateRangeMin: one(input[0], true), dateRangeMax: one(input[1], false) };
    }
    return { dateRangeMin: one(input, true), dateRangeMax: one(input, false) };
};
